import { useLayoutEffect as $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c } from "./useLayoutEffect.mjs";
import { useRef as $lmaYr$useRef, useCallback as $lmaYr$useCallback } from "react";

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  var ref = (0, $lmaYr$useRef)(null);
  (0, $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(function () {
    ref.current = fn;
  }, [fn]);
  // @ts-ignore
  return (0, $lmaYr$useCallback)(function () {
    var f = ref.current;
    return f === null || f === void 0 ? void 0 : f.apply(void 0, arguments);
  }, []);
}
export { $8ae05eaa5c114e9c$export$7f54fc3180508a52 as useEffectEvent };